<div id="card-total-container" [ngStyle]="{'width': fixedWidth ? fixedWidth + 'px' : 'unset'}">
    <p class="total">{{ total }}</p>
    <p class="title">{{ title }}</p>
</div>
